import { render, staticRenderFns } from "./dropdown-language.vue?vue&type=template&id=3ce35065&"
import script from "./dropdown-language.vue?vue&type=script&lang=js&"
export * from "./dropdown-language.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-language.vue?vue&type=style&index=0&id=3ce35065&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports